import { Stack } from '@superdispatch/ui';
import { TextBox } from '@superdispatch/ui-lab';
import { useFlag } from 'shared/settings/FeatureToggles';
import { PostingLoadDTO, PostingStepDTO } from '../../data/dto/PostingLoadDTO';
import {
  PostingAvailableDate,
  PostingAvailableNow,
} from './PostingAvailableDate';
import { PostingDescription } from './PostingDescription';
import {
  formatStepDate,
  getStepLabel,
  isPickupOpen,
  StepName,
} from './postingDateText';

export function PostingLoadDetailsDates({ load }: { load: PostingLoadDTO }) {
  const isEnabled = useFlag('slb_load_details_dates');

  if (!isEnabled) return <PostingAvailableDate {...load} />;

  if (!isPickupOpen(load.pickup)) return <PostingAvailableNow />;

  return (
    <Stack space="xxsmall">
      <PostingAvailableDate {...load} />
      <StepDateRow name="Pickup" step={load.pickup} />
      <StepDateRow name="Delivery" step={load.delivery} />
    </Stack>
  );
}

interface StepDateRowProps {
  name: StepName;
  step: PostingStepDTO;
}

function StepDateRow({ name, step }: StepDateRowProps) {
  const date = formatStepDate(step);
  if (!date) return null;

  return (
    <PostingDescription shouldWrap={true} label={getStepLabel(name, step)}>
      <TextBox display="inline">{date}</TextBox>
    </PostingDescription>
  );
}
